import { AlertTriangle, Check, X } from "lucide-react";
import { Button } from "@/components/ui/button";

interface ConfirmationBlockProps {
  toolCallId: string;
  toolName: string;
  message: string;
  state: "pending" | "approved" | "rejected";
  onApprove?: (toolCallId: string) => void;
  onReject?: (toolCallId: string) => void;
}

export function ConfirmationBlock({
  toolCallId,
  toolName,
  message,
  state,
  onApprove,
  onReject,
}: ConfirmationBlockProps) {
  return (
    <div className="my-2 rounded-lg border border-orange-500/30 bg-orange-500/5 p-3">
      <div className="flex items-start gap-2">
        <AlertTriangle className="mt-0.5 h-4 w-4 shrink-0 text-orange-500" />
        <div className="min-w-0 flex-1">
          <p className="text-sm font-medium">
            {toolName} requires approval
          </p>
          <p className="mt-1 text-sm text-muted-foreground">{message}</p>

          {state === "pending" && (
            <div className="mt-3 flex items-center gap-2">
              <Button
                size="sm"
                variant="outline"
                onClick={() => onReject?.(toolCallId)}
              >
                <X className="mr-1 h-3.5 w-3.5" />
                Reject
              </Button>
              <Button
                size="sm"
                onClick={() => onApprove?.(toolCallId)}
              >
                <Check className="mr-1 h-3.5 w-3.5" />
                Approve
              </Button>
            </div>
          )}

          {state === "approved" && (
            <div className="mt-2 flex items-center gap-1.5 text-sm text-green-600 dark:text-green-400">
              <Check className="h-3.5 w-3.5" />
              You approved this action
            </div>
          )}

          {state === "rejected" && (
            <div className="mt-2 flex items-center gap-1.5 text-sm text-red-600 dark:text-red-400">
              <X className="h-3.5 w-3.5" />
              You rejected this action
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
